import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "../../config";

const TemplateList = () => {
  const [templates, setTemplate] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // New state for error message

  useEffect(() => {
    fetchTemplates(selectedCategory);
    fetchCategory();
  }, [selectedCategory]);

  // Fetch templates with category
  const fetchTemplates = async (category) => {
    try {
      let url = "/api/templates/get-template";
      if (category) {
        const encodedCategory = encodeURIComponent(category); // Ensure the category is URL encoded
        url += `?categoryId=${encodedCategory}`; // Append category to URL
      }
      const temp = await apiClient.get(url);
      setTemplate(temp.data.data || []);
      setErrorMessage(""); // Clear error message when data is fetched successfully
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setErrorMessage("No templates found in this category");
        setTemplate([]); // Clear templates if no data is found
      } else {
        setErrorMessage("Failed to load templates");
      }
    }
  };

  // Fetch all categories
  const fetchCategory = async () => {
    try {
      const allCategory = await apiClient.get("/api/categories/get-category");
      setCategories(allCategory.data.data || []);
    } catch (e) {
      console.error("Failed to fetch categories", e);
    }
  };

  // Handle category selection
  const handleSelectCategory = (e) => {
    setSelectedCategory(e.target.value);
  };

  // Download the file
  const handleDownload = async (template) => {
    try {
      if (!template || !template.template_file) {
        alert("No file path specified for this template");
        return;
      }

      // If template_file starts with '/' we slice it to avoid double slashes,
      // because apiClient.get resolves relative to baseURL
      const relativePath = template.template_file.startsWith("/")
        ? template.template_file.slice(1)
        : template.template_file;

      const response = await apiClient.get(relativePath, {
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      
      const filename = template.template_file.split("/").pop() || `${template.template_name}`;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (e) {
      console.error("Failed to download template", e);
      alert("Failed to download template file");
    }
  };

  return (
    <div id="">
      <div className="">
            <div className="card bg-info-subtle shadow-none position-relative overflow-hidden mb-4 border-0">
              <div className="card-body px-4 py-3">
                <div className="row align-items-center">
                  <div className="col-9">
                    <h4 className="fw-semibold mb-8">Template List</h4>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                          <a
                            className="text-muted text-decoration-none"
                            href="#0">
                            Home
                          </a>
                        </li>
                        <li className="breadcrumb-item" aria-current="page">
                          <Link to={"/template"}>Template</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                          Template List
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-3">
                    <div className="text-center mb-n5">
                      <img
                        src="../../assets/assets/images/backgrounds/welcome-bg.svg"
                        alt="modernize-img"
                        className="img-fluid mb-n4"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div className="container-fluid">
            <div className="card mb-4">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-6 d-flex align-items-center gap-3">
                    <label className="form-label mb-0 fw-semibold" style={{ minWidth: "60px" }}>Filter</label>
                    <select
                      id="categorySearch"
                      className="form-select"
                      value={selectedCategory}
                      onChange={handleSelectCategory}>
                      <option value="">All Categories</option>
                      {categories.map((category) => {
                        return (
                          <option key={category._id} value={category._id}>
                            {category.category_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-striped table-hover align-middle mb-0">
                    <thead>
                      <tr>
                        <th scope="col" className="ps-4">
                          Template Name
                        </th>
                        <th scope="col">
                          Template Category
                        </th>
                        <th scope="col">
                          Template Description
                        </th>
                        <th scope="col" className="pe-4 text-end">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {errorMessage ? (
                        <tr>
                          <td colSpan="4" className="text-center py-4 text-muted">
                            {errorMessage}
                          </td>
                        </tr>
                      ) : templates.length > 0 ? (
                        templates.map((template) => (
                          <tr key={template._id}>
                            <td className="ps-4 fw-semibold" style={{ textTransform: "capitalize" }}>
                              {template.template_name}
                            </td>
                            <td style={{ textTransform: "capitalize" }}>
                              {template.category_name}
                            </td>
                            <td style={{ textTransform: "capitalize" }}>
                              {template.template_description}
                            </td>
                            <td className="pe-4 text-end">
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => {
                                  handleDownload(template);
                                }}>
                                <i className="ti ti-download me-1"></i> Download
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-4 text-muted">
                            No templates found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default TemplateList;
